import {
  ONLINE_OFFLINE_SETTLEMENTS_CHILDREN,
  REDIRECTION_MAPPER,
} from './constants';

export const updateFeatureItems = (featuresItems, eposActivated) => {
  const updatedFeatureItems = [...featuresItems];
  if (eposActivated) {
    const settlementIdx = featuresItems.findIndex(
      item => item.key === 'settlements',
    );
    if (settlementIdx !== -1) {
      const updatedSettlementObj = {
        ...updatedFeatureItems[settlementIdx],
        children: ONLINE_OFFLINE_SETTLEMENTS_CHILDREN,
      };
      updatedFeatureItems[settlementIdx] = updatedSettlementObj;
    }
  }

  return updatedFeatureItems;
};

export const getRedirectionMapper = (showOCCActivated, mapKey) => {
  if (showOCCActivated && mapKey === 'OFFER')
    return REDIRECTION_MAPPER.OCC_ACTIVATED_OFFER;
  if (showOCCActivated && mapKey === 'NO_COST_EMI')
    return REDIRECTION_MAPPER.OCC_ACTIVATED_NO_COST_EMI;
  return REDIRECTION_MAPPER[mapKey];
};
